// API Configuration
// Centralized API URL management with environment variable support

const getApiBaseUrl = (): string => {
  // Check environment variables in order of preference
  const envUrl = import.meta.env.VITE_API_URL;
  const defaultUrl = 'https://family-membership-system.jositett.workers.dev'; // Remote URL
  // const defaultUrl = 'http://localhost:8787'; // Local development URL
  
  // Return environment URL if available, otherwise use default
  return envUrl || defaultUrl;
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  ENDPOINTS: {
    AUTH: "/api/auth",
    MEMBERS: "/api/members",
    TOWNS: "/api/towns",
    TOWNS_TEST: "/api/towns/{id}/test",
    TOWNS_MIGRATE: "/api/towns/{id}/migrate-members",
    TOWNS_DISABLE: "/api/towns/{id}/disable",
    CONTRIBUTIONS: "/api/contributions",
    CONTRIBUTIONS_PENDING_APPROVALS: "/api/contributions/pending-approvals",
    EVENTS: "/api/events",
    EXPENSES: "/api/expenses",
    BENEFITS: "/api/benefits",
    ADMINS: "/api/admins",
    SMS: "/api/sms",
    REPORTS: "/api/reports",
    PAYMENTS: "/api/payments",
    PAYMENT_SETTINGS: "/api/payment-settings",
    SETTINGS: "/api/settings",
    SETTINGS_NOTIFICATIONS: "/api/settings/notifications",
    BRAND: "/api/brand",
    BRAND_EDIT: "/api/brand/edit",
    SETTINGS_NOTIFICATIONS_TEST: "/api/settings/notifications/test",
    NOTIFICATIONS: "/api/notifications",
    MESSAGES: "/api/messages",
    AUDIT_LOGS: "/api/audit-logs",
    STATS: "/api/stats",
    STATS_DATABASE: "/api/stats/database",
    DASHBOARD: "/api/dashboard",
    APPROVALS: "/api/approvals",
    SYSTEM: "/api/system",
    SYSTEM_PERFORMANCE: "/api/system/performance",
    SYSTEM_USERS: "/api/system/users",
    SYSTEM_SESSIONS: "/api/system/sessions",
    SYSTEM_LOGOUT_ALL: "/api/system/logout-all",
    SYSTEM_SECURITY_SCAN: "/api/system/security-scan",
    UPLOAD: "/api/upload",
    BULK: "/api/bulk",
    DEV_SYSTEM_CONFIG: "/api/dev/system-config",
    DEV_SETTINGS: "/api/dev/settings",
    DEV_SETTINGS_PAYMENTS: "/api/dev/settings/payments",
    DEV_SETTINGS_NOTIFICATIONS: "/api/dev/settings/notifications",
    DEV: "/api/dev",
    ERRORS: "/api/errors",
    REPORTS_CUSTOM: "/api/reports/custom",
    HEALTH: "/api/health",
    REMINDERS: "/api/reminders",
    REMINDERS_CONFIG: "/api/reminders/config",
    REMINDERS_STATS: "/api/reminders/stats",
    REMINDERS_TRIGGER: "/api/reminders/trigger",
    REMINDERS_TEST: "/api/reminders/test",
    EMAIL: "/api/email",
    EMAIL_SEND: "/api/email/send",
    EMAIL_HISTORY: "/api/email/history",
    EMAIL_TEST: "/api/email/test",
    USERS: "/api/users",
    ASSIGNMENTS: "/api/assignments",
    ASSIGNMENTS_MONTHLY: "/api/assignments/monthly",
    ASSIGNMENTS_HISTORY: "/api/assignments/history",
    ASSIGNMENTS_MEMBER_SUMMARY: "/api/assignments/member",
    ASSIGNMENTS_ARREARS: "/api/assignments/arrears",
    ASSIGNMENTS_CONFIG: "/api/assignments/config",
  },
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
